import { render, staticRenderFns } from "./WorkplaceActivateModal.vue?vue&type=template&id=37f0f56a&"
import script from "./WorkplaceActivateModal.vue?vue&type=script&lang=js&"
export * from "./WorkplaceActivateModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceActivateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports